<template>
	<div class="container ar">
		<div class="search-back" @click.self="closeSearch">
			<div class="search-container">
				<!-- search-input -->
				<div class="search-input">
					<img src="/assets/Icons/Search.png" alt />
					<input
						v-model="globalSearch"
						type="text"
						:placeholder="$t('navbar.search')"
						@keydown.enter="submit" />
				</div>
				<button class="justify-content-center search-button" @click="submit">
					{{ $t('navbar.search') }}
				</button>
				<hr />

				<button
					v-if="!showAdvanceSearch"
					class="show-advance-search"
					@click="showAdvanceSearch = true">
					{{ $t('navbar.advance-search') }}
				</button>
				<form @submit.prevent="submitAdvance" ref="form" :class="{ show: showAdvanceSearch }">
					<p>{{ $t('navbar.search-options') }}</p>
					<div class="search-option">
						<!-- ISSN -->
						<div class="search-title">{{ $t('navbar.issn') }}</div>
						<input v-model="issn" type="text" :placeholder="$t('navbar.enter-issn')" />

						<!-- search date -->
						<div class="search-title">{{ $t('navbar.date') }}</div>
						<div class="search-date">
							<slider ref="slider" @change-date="changeDate" v-model="data"></slider>
						</div>

						<!-- keyworks -->
						<div class="search-title">{{ $t('navbar.keywords') }}</div>
						<input v-model="keyword" type="text" :placeholder="$t('navbar.keywords')" />

						<!-- article -->
						<div class="search-title">{{ $t('navbar.title') }}</div>
						<input v-model="article" type="text" :placeholder="$t('navbar.enter-title')" />

						<!-- publisher -->
						<div class="search-title">{{ $t('navbar.writer') }}</div>

						<loader height="2rem" :small="true" v-if="loading"></loader>
						<input
							v-else
							:placeholder="$t('navbar.enter-writer')"
							list="browsers"
							@input="checkSelection"
							v-model="publisherModel" />
						<datalist id="browsers">
							<option
								v-for="publisher in publishers"
								:value="publisher.name"
								:key="publisher.id">
								{{ publisher.name }}
							</option>
						</datalist>

						<!-- serie -->
						<div class="search-title">{{ $t('navbar.series') }}</div>
						<loader height="2rem" :small="true" v-if="loading"></loader>
						<select v-else v-model="serie" name="series" :disabled="loading">
							<option value selected disabled hidden>{{ $t('navbar.enter-series') }}</option>
							<option v-for="serie in series" :key="serie.id" :value="serie.name">
								{{ serie.name }}
							</option>
						</select>

						<!-- volume -->
						<div class="search-title">{{ $t('navbar.volume') }}</div>
						<loader height="2rem" :small="true" v-if="loading"></loader>
						<select v-else v-model="volume" name="issie" :disabled="loading">
							<option value selected disabled hidden>{{ $t('navbar.enter-volum') }}</option>
							<option v-for="volume in volumes" :key="volume.id" :value="volume.name">
								{{ volume.name }}
							</option>
						</select>
						<button class="justify-content-center" type="submit">
							{{ $t('navbar.advance-search') }}
						</button>
					</div>
				</form>
			</div>
		</div>
		<div>
			<div class="nav-small">
				<div class="lung-drawer">
					<img
						class
						src="/assets/Icons/nav.png"
						style="cursor: pointer"
						alt
						@click="openDrawer = !openDrawer" />
					<div class="lung" @click="showLungS">
						<div class="lung-image">
							<i class="fas fa-globe-americas"></i>
						</div>
						<div class="lung-list small">
							<div class="lung-item" @click="changeLanguage('ar')">عربي</div>
							<div class="lung-item" @click="changeLanguage('ar')">English</div>
						</div>
					</div>
				</div>
				<router-link :to="{ name: 'home' }" class="text-center">
					<img class="ns-logo" src="/assets/CompanyLogo/logo.png" alt />
				</router-link>
				<img class src="/assets/Icons/Search.png" alt @click="openSearch" ref="nsSearchIcon" />
				<!-- <div class="ns-search-input" ref="nsSearchInput">
          <input type="text" class="" />
				</div>-->
			</div>
			<ul class="nav" :class="{ show: openDrawer }">
				<li class="lung" @click="showLung">
					<div class="lung-image">
						<i class="fas fa-globe-americas"></i>
					</div>
					<div class="lung-list big">
						<div class="lung-item" @click="changeLanguage('ar')">عربي</div>
						<div class="lung-item" @click="changeLanguage('en')">English</div>
					</div>
				</li>
				<li class="nav-item">
					<router-link :to="{ name: 'home' }" @click="openDrawer = false">
						{{ $t('links.home') }}
					</router-link>
				</li>
				<li class="nav-item">
					<router-link :to="{ name: 'all-series' }" @click="openDrawer = false">{{
						$t('links.series')
					}}</router-link>
				</li>
				<li class="nav-item">
					<router-link :to="{ name: 'all-news' }" @click="openDrawer = false">{{
						$t('links.news')
					}}</router-link>
				</li>
				<li class="nav-item">
					<router-link :to="{ name: 'publishing-rules' }" @click="openDrawer = false">{{
						$t('links.rules')
					}}</router-link>
				</li>
				<router-link class="nav-item nav-icon" :to="{ name: 'home' }">
					<img class src="/assets/CompanyLogo/logo.png" alt />
				</router-link>
				<li class="nav-item">
					<router-link :to="{ name: 'editorial-board' }" @click="openDrawer = false">{{
						$t('links.editorial')
					}}</router-link>
				</li>
				<li class="nav-item">
					<router-link :to="{ name: 'join-us' }" @click="openDrawer = false">{{
						$t('links.join-us')
					}}</router-link>
				</li>
				<li class="nav-item">
					<router-link :to="{ name: 'about-us' }" @click="openDrawer = false">{{
						$t('links.about')
					}}</router-link>
				</li>
				<li class="nav-item">
					<router-link :to="{ name: 'contant' }" @click="openDrawer = false">{{
						$t('links.contact')
					}}</router-link>
				</li>
				<li class="nav-item nav-search-icon">
					<img class src="/assets/Icons/Search.png" alt @click="openSearch" ref="searchIcon" />
					<!-- <div class="search-input" ref="searchInput">
            <input type="text" class="" />
					</div>-->
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import Loader from '@/components/Loader';
import Slider from './slider';
import { mapState } from 'vuex';
export default {
	components: {
		Slider,
		Loader,
	},
	data() {
		return {
			loading: true,

			searchSmall: false,
			search: false,

			globalSearch: null,
			issn: null,
			date: null,
			keyword: null,
			article: null,
			publisher: null,
			publisherModel: null,
			serie: '',
			volume: '',
			openDrawer: false,

			showAdvanceSearch: false,
		};
	},
	methods: {
		showDrawer() {
			this.$refs.drawer.classList.toggle('show');
		},
		showSearchMob() {
			this.$refs.nsSearchInput.classList.toggle('show');
			this.searchSmall
				? (this.$refs.nsSearchIcon.src = '/assets/Icons/Search.png')
				: (this.$refs.nsSearchIcon.src = '/assets/Icons/Search-c.png');
			this.searchSmall = !this.searchSmall;
		},
		showSearch() {
			this.$refs.searchInput.classList.toggle('show');
			this.search
				? (this.$refs.searchIcon.src = '/assets/Icons/Search.png')
				: (this.$refs.searchIcon.src = '/assets/Icons/Search-c.png');
			this.search = !this.search;
		},
		closeSearch() {
			document.querySelector('.search-container').style.transform = 'translateX(-100%)';
			setTimeout(() => {
				document.querySelector('.search-back').style.visibility = 'hidden';
			}, 505);
		},
		openSearch() {
			document.querySelector('.search-back').style.visibility = 'visible';

			document.querySelector('.search-container').style.transform = 'translateX(0)';
		},
		showLung() {
			document.querySelector('.lung-list.big').classList.toggle('show');
		},
		showLungS() {
			document.querySelector('.lung-list.small').classList.toggle('show');
		},

		changeDate(date) {
			this.date = date;
		},

		isEmpty(prop) {
			if (prop === null || prop === '') {
				return true;
			} else return false;
		},

		setQuery() {
			var query = {};
			// if (!this.isEmpty(this.globalSearch)) {
			//   query.search = this.globalSearch;
			// }
			if (!this.isEmpty(this.issn)) {
				query.issn = this.issn;
			}
			if (!this.isEmpty(this.date)) {
				query.startDate = this.date[0];
				query.endDate = this.date[1];
			}
			if (!this.isEmpty(this.keyword)) {
				query.keyword = this.keyword;
			}
			if (!this.isEmpty(this.article)) {
				query.article = this.article;
			}
			if (!this.isEmpty(this.publisher)) {
				query.publisher = this.publisher;
			}
			if (!this.isEmpty(this.serie)) {
				query.serie = this.serie;
			}
			if (!this.isEmpty(this.volume)) {
				query.volume = this.volume;
			}

			return query;
		},

		reset() {
			this.globalSearch = null;
			this.issn = null;
			this.date = null;
			this.keyword = null;
			this.article = null;
			this.publisher = null;
			this.publisherModel = null;
			this.serie = '';
			this.volume = '';
			this.$refs.slider.reset();
		},

		submit() {
			if (this.globalSearch) {
				this.$router.push({
					name: 'search-result',
					query: {
						search: this.globalSearch,
					},
				});
			}

			this.reset();
			this.closeSearch();
		},

		submitAdvance() {
			if (!this.isAllEmpty) {
				this.$router.push({
					name: 'search-result',
					query: this.setQuery(),
				});

				this.reset();
				this.closeSearch();
			}
		},

		checkSelection(e) {
			if (!this.publishers.find((c) => c.name === e.target.value)) {
				this.publisher = '';
			} else {
				this.publisher = this.publishers.find((c) => c.name === e.target.value).id;
				this.publisherModel = e.target.value;
			}
		},

		changeLanguage(lang) {
			this.$emit('change-lang', lang);
		},
	},

	computed: {
		isAllEmpty() {
			return (
				this.globalSearch === null &&
				this.issn === null &&
				this.date === null &&
				this.keyword === null &&
				this.article === null &&
				this.publisher === null &&
				this.serie === '' &&
				this.volume === ''
			);
		},
		...mapState({
			series: (state) => state.series.series,
			volumes: (state) => state.volumes.volumes,
			publishers: (state) => state.publishers.publishers,
		}),
	},

	mounted() {
		Promise.all([
			this.$store.dispatch('publishers/fetchAll'),
			this.$store.dispatch('volumes/fetchAll'),
			this.$store.dispatch('series/fetchAll'),
		]).finally(() => {
			this.loading = false;
		});
	},
};
</script>

<style scoped>
.container {
	box-shadow: 0 3px 50px #ccc;
}
.nav-small {
	display: none;
}
.nav {
	list-style: none;
	display: flex;
	padding: 5px 50px;
	justify-content: space-around;
	align-items: center;
}
.nav-item {
	font-family: changeMedium;
	white-space: nowrap;
	font-size: 15px;
}
.nav-icon img {
	height: 70px;
	padding: 0 30px;
	margin-bottom: 8px;
}
.nav-search-icon img {
	height: 15px;
}
.nav-search-icon {
	cursor: pointer;
	position: relative;
}
.search-back {
	position: fixed;
	background: #0009;
	visibility: hidden;
	width: 100%;
	height: 100vh;
	z-index: 100;
}
.search-container {
	height: 100%;
	width: 350px;
	background: white;
	left: 0;
	position: absolute;
	padding: 20px;
	overflow: auto;
	transition: 500ms;
	transform: translateX(-100%);
	overflow-x: hidden;
	/* position: relative; */
}
.search-container form {
	max-height: 0;
	overflow: hidden;
	transition: 0.5s;
}
.show-advance-search {
	margin: 30px 0 10px;
	background: linear-gradient(to right, var(--yellow-color-2), var(--green-color));
	color: white;
	padding: 5px 10px;
	width: 100%;
	border: none;
	border-radius: 7px;
	font-family: changeBold;
}
.search-container form.show {
	max-height: 100vh;
}
.search-input {
	width: 100%;
	height: 40px;
	padding: 5px;
	border: 2px solid #ccc;
	border-radius: 10px;
}
.search-input input {
	width: 90%;
	height: 100%;
	border: none;
	outline: none;
}

.search-input img {
	padding: 5px;
	height: 100%;
	width: 10%;
	object-fit: contain;
}
.search-container p {
	display: block;
	width: max-content;
	background: white;
	margin: 20px 10px -10px;
	padding: 2px 15px;
	position: relative;
	font-family: changeMedium;
	font-size: 18px;
}
.search-option {
	padding: 0 10px 10px;
	border: 2px solid #ccc;
	border-radius: 10px;
}
.search-title {
	padding: 10px 0 5px;
	font-family: changeMedium;
	font-size: 14px;
}
.search-option input,
.search-option select,
.search-option datalist {
	width: 100%;
	height: 30px;
	border: 1px solid var(--borders-color);
	border-radius: 7px;
	padding: 2px 10px;
	font-size: 13px;
}
.search-date {
	height: 50px;
	padding-top: 40px;
}
.search-button {
	margin: 10px 0;
	background: linear-gradient(to right, var(--yellow-color-2), var(--green-color));
	color: white;
	padding: 5px 10px;
	border: none;
	border-radius: 7px;
	font-family: changeBold;
}
.search-option button {
	margin: 30px 0 10px;
	background: linear-gradient(to right, var(--yellow-color-2), var(--green-color));
	color: white;
	padding: 5px 10px;
	height: 40px;
	width: 100%;
	border: none;
	border-radius: 7px;
	font-family: changeBold;
}
.search-option button:hover {
	box-shadow: 0 0 5px #333;
}
.search-option input:focus:not([type='range']),
.search-option select:focus {
	outline: 2px solid var(--green-color);
}
.lung {
	position: relative;
}
.lung-image {
	width: 20px;
	height: 20px;
}
.lung-image svg {
	height: 100%;
	width: 100%;
}
.lung-list {
	position: absolute;
	background: white;
	padding: 10px;
	border-radius: 10px;
	box-shadow: 1px 1px 5px #eee;
	top: 150%;
	right: -50%;
	z-index: 100;
	display: none;
}
.lung-item {
	font-size: 14px;
	padding: 10px;
	text-align: center;
}
.lung-item:first-child {
	border-bottom: 1px solid var(--borders-color);
}
.lung-item:hover {
	color: var(--green-color);
	cursor: pointer;
}
.lung-list.big.show {
	display: block;
}
.lung-list.small.show {
	display: block;
}
@media only screen and (max-width: 992px) {
	.container {
	}
	.nav-small {
		height: 100px;
		padding: 5px 20px 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: relative;
	}
	.nav-small > img {
		height: 30%;
	}
	.lung-drawer {
		height: 30%;
		position: relative;
	}
	.lung-drawer img {
		height: 100%;
	}
	.lung-drawer > .lung {
		position: absolute;
		top: 3px;
		left: -150%;
	}
	.ns-logo {
		width: 45%;
	}
	.ns-search-input {
		position: absolute;
		top: -100px;
		right: 0;
		transition: 200ms;
		width: 85%;
		height: 100%;
		background: white;
		padding: 20px;
	}
	.ns-search-input input {
		width: 100%;
		height: 80%;
		border: none;
		border-bottom: 2px solid var(--borders-color);
	}
	.ns-search-input input:focus {
		outline: none;
		border-bottom: 2px solid var(--green-color);
	}
	.ns-search-input.show {
		top: 0;
	}
	.nav {
		padding-top: 20px;
		flex-direction: column;
		flex-wrap: wrap;
		position: absolute;
		width: 100%;
		height: 220px;
		background: var(--grey-color);
		transform: translateY(-1000px);
		transition: 500ms cubic-bezier(0.25, 0.46, 0.46, 0.8);
		top: 100px;
		z-index: 3;
	}
	.nav-item {
		height: 40px;
		color: white !important;
	}
	.nav-icon,
	.nav-search-icon {
		display: none;
	}
	.nav.show {
		transform: translateY(0);
	}
	li.lung {
		display: none;
	}
}
@media only screen and (max-width: 567px) {
	.nav {
		flex-wrap: nowrap;
		height: 500px;
	}
	.search-container {
		width: 80%;
	}
}
</style>
